import { CompanyDto } from './companyDto'

export class NeedsDriversLicensePhotoUploadedDetailsDto {
  outboundTripNumber?: string = undefined
  outboundTripDate?: string = undefined
  outboundTransporterCompany?: CompanyDto = undefined
  vehiclesInOutboundTrip?: string[] = undefined
  notes?: string = undefined
}
